export default __webpack_public_path__ + "static/media/cards1-(1)-(1).170e3cee.png";